/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UbereatsTokenValidationResponse } from '../../models/ubereats-token-validation-response';

export interface UbereatsOauthTokenGet$Params {
  'Active-Tenant-Identifier': string;
}

export function ubereatsOauthTokenGet(http: HttpClient, rootUrl: string, params: UbereatsOauthTokenGet$Params, context?: HttpContext): Observable<StrictHttpResponse<UbereatsTokenValidationResponse>> {
  const rb = new RequestBuilder(rootUrl, ubereatsOauthTokenGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UbereatsTokenValidationResponse>;
    })
  );
}

ubereatsOauthTokenGet.PATH = '/ubereats/oauth/token';
